export const PageTypes = Object.freeze({
  IMAGE: 0,
  CSV: 1,
  PDF: 2,
  URL: 4,
  VIDEO: 5,
  SEARCHABLE: 6,
});
